import { hasValue } from "lib/utils/hasValue";
import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

export async function getProject(projectId) {
  // STEP 1 : 파라미터 가드
  if (!hasValue(projectId)) {
    console.warn("⚠️ [getProject] Id 누락");
    return { success: false, message: "유효하지 않은 ID입니다." };
  }

  try {
    // ✅ STEP 2 : 요청 경로(path)만 구성
    const path = `${BACKEND_URL}/project/get_project/${projectId}`;

    // STEP 3 : Fetch (✅ authFetch로 교체)
    const res = await authFetch(
      path,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      {
        // 기존 값 유지
        refreshUrlIncludes: "auth/refresh",
      },
    );

    // STEP 4 : 응답 파싱
    const result = await res.json().catch(() => null);

    if (!result) {
      return { success: false, message: "서버 응답 파싱 실패" };
    }

    if (res.status === 401) {
      return {
        success: false,
        message: "인증이 만료되었습니다. 다시 로그인해 주세요.",
      };
    }

    if (!res.ok || !result?.success) {
      console.warn(
        `[STEP 4-FAIL] : 서버 오류 또는 실패 응답 → ${
          result?.message || "조회 실패"
        }`,
      );
      return { success: false, message: result?.message || "조회 실패" };
    }

    // STEP 5 : 최종 반환 (프로젝트 정보만)
    return {
      success: true,
      message: result.message,
      project: result.data?.project ?? null,
    };
  } catch (err) {
    console.error("❌ [getProject] 요청 실패:", err);
    return { success: false, message: "서버 요청 중 오류가 발생했습니다." };
  }
}
